import { render, staticRenderFns } from "./SkillsSec.vue?vue&type=template&id=69ca745d&"
import script from "./SkillsSec.vue?vue&type=script&lang=js&"
export * from "./SkillsSec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports